import styled from '@emotion/styled'

interface Props {
  bold?: boolean
  center?: boolean
  color?: string
  dense?: boolean
  muted?: boolean
  small?: boolean
  smaller?: boolean
  tiny?: boolean
  uppercase?: boolean
  wizard?: boolean
  wizardBig?: boolean
}

const P = styled.p<Props>(
  ({ theme }) => theme.fontSmooth,
  ({ theme }) => ({
    color: theme.colors.text,
    fontFamily: theme.fonts.families.body,
    fontSize: '16px',
    fontWeight: 'normal',
    letterSpacing: '0.4px',
    lineHeight: '20px',
    [theme.mediaQueries.maxDesktop]: {
      fontSize: '14px',
      lineHeight: '20px',
      letterSpacing: '0.35px,',
    },
  }),
  (props) =>
    !!props.dense && {
      marginBottom: '0.2em',
    },
  (props) =>
    !!props.small && {
      fontSize: props.theme.fonts.sizes.P.small,
    },
  (props) =>
    !!props.smaller && {
      fontSize: props.theme.fonts.sizes.P.smaller,
    },
  (props) =>
    !!props.tiny && {
      fontSize: props.theme.fonts.sizes.P.tiny,
      lineHeight: '12px',
    },
  (props) =>
    !!props.center && {
      textAlign: 'center',
    },
  (props) =>
    props.color === 'gray' && {
      color: props.theme.colors.grays.gray,
    },
  (props) =>
    props.color === 'primary' && {
      color: props.theme.colors.main.primary,
    },
  (props) =>
    !!props.muted && {
      color: props.theme.colors.grays.grayLight,
    },
  (props) =>
    !!props.uppercase && {
      textTransform: 'uppercase',
    },
  (props) =>
    !!props.bold && {
      fontWeight: 700,
    },
  (props) =>
    props.wizard && {
      fontSize: props.theme.fonts.sizes.P.wizard,
      fontWeight: 300,
    }
)

export const PDiv = P.withComponent('div')
export const PSpan = P.withComponent('span')

export default P
